const Images = {
  logo: require("./logo/logo.png"),
  profile: require("./profile/profile.jpg"),
  html: require("./skills/html.png"),
  css: require("./skills/css.jpg"),
  js: require("./skills/js.png"),
  react: require("./skills/react.png"),
  tailwind: require("./skills/tailwind.png"),
  heroku: require("./skills/heroku.webp"),
  git: require("./skills/git.png"),
  github: require("./skills/github.png"),
  bootstrap: require("./skills/bootstrap.png"),
  c: require("./skills/C.png"),
  express: require("./skills/express js.png"),
  firebase: require("./skills/firebase.jpg"),
  framer: require("./skills/framer.jpg"),
  jquery: require("./skills/j query.jpg"),
  materialui: require("./skills/material ui.png"),
  netlify: require("./skills/netlify.png"),
  nodejs: require("./skills/node js.png"),
  vscode: require("./skills/vs code.png"),
  python: require("./skills/python.png"),
  contact: require("./contact/contact.png"),
  school: require("./education/school.jpg"),
  college: require("./education/college.jpg"),
  hero: require("./hero/hero-1.png"),
  axar: require("./project/axar.png"),
  loremIpsum: require("./project/lorem-ipsum.png"),
  expenseTracker: require("./project/expense-tracker.png"),
  cocktails: require("./project/cocktails.png"),
  cart: require("./project/cart.png"),
  qtrip: require("./project/qtrip.png"),
};

export default Images;
